// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.StackedColumnChart_scroll__loY09::-webkit-scrollbar {
  height: 8px;
}
.StackedColumnChart_scroll__loY09::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.StackedColumnChart_scroll__loY09::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.StackedColumnChart_StackedColumnChart__uQBGi {
  position: relative;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_unAnalyzed__HOyho {
  position: absolute;
  max-width: 50%;
  text-transform: uppercase;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-weight: 900;
  font-size: 14px !important;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__S9X5M {
  background-color: var(--bgColor);
  min-height: 272px;
  position: relative;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__S9X5M[data-minheight=false] {
  min-height: auto;
  margin-bottom: 30px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX {
    flex-wrap: wrap;
  }
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Filters__3g3py {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Filters__3g3py {
    width: 95%;
    margin-bottom: 10px;
  }
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Filters__3g3py .StackedColumnChart_Select__9KVeG {
  width: 127px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Filters__3g3py .StackedColumnChart_Select__9KVeG:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu svg {
  transition: 0.3s;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu svg:hover {
  color: var(--secondaryColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu svg:hover line {
  stroke: var(--secondaryColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu svg:hover path {
  stroke: var(--secondaryColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu .StackedColumnChart_ActionBtn__PM9nI {
  flex-shrink: 0;
  position: relative;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_ChartBox__toolBar__eWOpX .StackedColumnChart_Actions__qAmvu .StackedColumnChart_ActionBtn__PM9nI:not(:last-child) {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_specityChartHolder__3dUxa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
}
@media (max-width: 992px) {
  body[dir=ltr] .StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_specityChartHolder__3dUxa {
    padding-left: 0;
  }
  body[dir=rtl] .StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_specityChartHolder__3dUxa {
    padding-right: 0;
  }
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_specifyChart__T6ZeW {
  display: flex;
  align-items: center;
}
.StackedColumnChart_StackedColumnChart__uQBGi .StackedColumnChart_colorBox__w4K9K {
  min-width: 12px;
  height: 12px;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  border: 1px solid;
}
.StackedColumnChart_StackedColumnChart__uQBGi .title_name {
  padding: 0 16px 10px 16px;
  display: flex;
  align-items: center;
}
.StackedColumnChart_StackedColumnChart__uQBGi .title_name h6 {
  font-size: 12px !important;
  text-transform: uppercase;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip {
  padding: 16px 0;
  border: 1px solid var(--borderColor);
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  width: 272px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  padding: 0 16px 10px 16px;
  background-color: transparent;
  margin-bottom: 0;
  font-size: 0 !important;
  text-transform: uppercase;
  color: var(--mainColor);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 0;
  display: none;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title::before {
  content: "Hashtags";
  font-size: 12px !important;
  flex-basis: 72%;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title::after {
  content: "Mentions";
  display: block;
  font-size: 12px !important;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip.apexcharts-theme-light {
  background-color: var(--bgColor);
  border: var(--borderColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group {
  padding: 0 16px;
  font-size: 10px !important;
  width: 100%;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group:not(:last-child) {
  margin-bottom: 9px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group .apexcharts-tooltip-marker {
  flex-shrink: 0;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group .apexcharts-tooltip-y-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  font-size: 10px !important;
  color: var(--mainColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group .apexcharts-tooltip-text {
  width: 100%;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group .apexcharts-tooltip-text-label {
  flex-basis: 70%;
}
.StackedColumnChart_StackedColumnChart__uQBGi .apexcharts-tooltip-series-group .apexcharts-tooltip-text-value {
  margin-left: 0;
  font-weight: 400;
  color: var(--mainColor);
}
.StackedColumnChart_StackedColumnChart__uQBGi .arrow_box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}
.StackedColumnChart_StackedColumnChart__uQBGi .arrow_box > div h6 {
  font-size: 12px !important;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.StackedColumnChart_StackedColumnChart__uQBGi .arrow_box > div > div > div {
  font-size: 10px !important;
  margin-bottom: 10px;
  max-width: 155px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1;
  height: 12px;
}

.color_name {
  display: flex;
  align-items: center;
}
.color_name .colorBox {
  min-width: 12px;
  height: 12px;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  border: 1px solid;
  margin-bottom: 0 !important;
}

.StackedColumnChart_withSecondaryTable__XZAgC {
  height: 0 !important;
}

body[dir=rtl] .apexcharts-yaxis-texts-g.apexcharts-xaxis-inversed-texts-g {
  transform: translateX(-5%) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/StackedColumnChart/StackedColumnChart.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,kBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAuDJ;AArDE;EACE,gCAAA;EACA,iBAAA;EACA,kBAAA;AAuDJ;AApDI;EACE,gBAAA;EACA,mBAAA;AAsDN;AAnDI;EAEE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAoDN;ADwEE;ECjIE;IAQI,eAAA;EAqDN;AACF;AAnDM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;AAqDR;AD6DE;ECtHI;IAOI,UAAA;IACA,mBAAA;EAsDR;AACF;AApDQ;EACE,YAAA;AAsDV;AApDU;EACE,wBAAA;UAAA,uBAAA;AAsDZ;AAjDM;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAmDR;AAlDQ;EACE,gBAAA;AAoDV;AAnDU;EACE,4BAAA;AAqDZ;AApDY;EACE,6BAAA;AAsDd;AApDY;EACE,6BAAA;AAsDd;AAjDQ;EACE,cAAA;EACA,kBAAA;AAmDV;AAjDU;EAEE,yBAAA;UAAA,wBAAA;EACA,gDAAA;UAAA,+CAAA;AAkDZ;AAvBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAyBJ;ADgBE;ECvCI;IACE,eAAA;EA0BN;EAxBI;IACE,gBAAA;EA0BN;AACF;AAvBE;EACE,aAAA;EACA,mBAAA;AAyBJ;AApBE;EACE,eAAA;EACA,YAAA;EACA,uBAAA;UAAA,sBAAA;EACA,iBAAA;AAsBJ;AAnBI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AAqBN;AApBM;EDlCF,0BAAA;ECoCI,yBAAA;EACA,wBAAA;UAAA,uBAAA;AAsBR;AAnBI;EACE,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAqBN;AAlBI;EACE,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;AAoBN;AAlBM;EACE,mBAAA;ED/DJ,0BAAA;ECiEI,eAAA;AAoBR;AAjBM;EACE,mBAAA;EACA,cAAA;EDtEJ,0BAAA;AC0FJ;AAhBI;EACE,gCAAA;EACA,0BAAA;AAkBN;AAhBI;EACE,eAAA;EDjFF,0BAAA;ECmFE,WAAA;AAkBN;AAhBM;EACE,kBAAA;AAkBR;AAfM;EACE,cAAA;AAiBR;AAdM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EDjGJ,0BAAA;ECmGI,uBAAA;AAgBR;AAbM;EACE,WAAA;AAeR;AAZM;EACE,eAAA;AAcR;AAXM;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;AAaR;AAPI;EACE,aAAA;EAEA,8BAAA;EACA,eAAA;AAQN;AANM;ED3HF,0BAAA;EC6HI,mBAAA;EACA,yBAAA;AAQR;AALM;EDnIF,0BAAA;ECqII,mBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAMR;;AAAE;EACE,aAAA;EACA,mBAAA;AAGJ;AAFI;EACE,eAAA;EACA,YAAA;EACA,uBAAA;UAAA,sBAAA;EACA,iBAAA;EACA,2BAAA;AAIN;;AAAA;EACE,oBAAA;AAGF;;AACI;EACE,qCAAA;AAEN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.StackedColumnChart {\n  position: relative;\n  .unAnalyzed {\n    position: absolute;\n    max-width: 50%;\n    text-transform: uppercase;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    font-weight: 900;\n    font-size: 14px !important;\n  }\n  .ChartBox {\n    background-color: var(--bgColor);\n    min-height: 272px;\n    position: relative;\n    // padding: 20px;\n\n    &[data-minheight='false'] {\n      min-height: auto;\n      margin-bottom: 30px;\n    }\n\n    &__toolBar {\n      // margin-bottom: 20px;\n      padding: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      @include Sm {\n        flex-wrap: wrap;\n      }\n\n      .Filters {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        flex-shrink: 0;\n\n        @include Sm {\n          width: 95%;\n          margin-bottom: 10px;\n        }\n\n        .Select {\n          width: 127px;\n\n          &:not(:last-child) {\n            margin-inline-end: 10px;\n          }\n        }\n      }\n\n      .Actions {\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        svg {\n          transition: 0.3s;\n          &:hover {\n            color: var(--secondaryColor);\n            line {\n              stroke: var(--secondaryColor);\n            }\n            path {\n              stroke: var(--secondaryColor);\n            }\n          }\n        }\n\n        .ActionBtn {\n          flex-shrink: 0;\n          position: relative;\n\n          &:not(:last-child) {\n            // margin-inline-end: 10px;\n            padding-inline-end: 10px;\n            border-inline-end: 1px solid var(--borderColor);\n          }\n\n          // &:not(:first-child)::before {\n          //   content: '';\n          //   width: 1px;\n          //   height: 13px;\n          //   display: block;\n          //   position: absolute;\n          //   top: 50%;\n          //   transform: translateY(-50%);\n          //   -webkit-transform: translateY(-50%);\n          //   -moz-transform: translateY(-50%);\n          //   -ms-transform: translateY(-50%);\n          //   -o-transform: translateY(-50%);\n          //   #{$ltr} & {\n          //     left: -10px;\n          //   }\n          //   #{$rtl} & {\n          //     left: 10px;\n          //   }\n          //   margin: 0 10px;\n          // }\n        }\n      }\n    }\n  }\n  .specityChartHolder {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    width: 100%;\n    @include Sm {\n      #{$ltr} & {\n        padding-left: 0;\n      }\n      #{$rtl} & {\n        padding-right: 0;\n      }\n    }\n  }\n  .specifyChart {\n    display: flex;\n    align-items: center;\n    // &:not(:last-child) {\n    //   margin-inline-end: 30px;\n    // }\n  }\n  .colorBox {\n    min-width: 12px;\n    height: 12px;\n    margin-inline-end: 4px;\n    border: 1px solid;\n  }\n  :global {\n    .title_name {\n      padding: 0 16px 10px 16px;\n      display: flex;\n      align-items: center;\n      h6 {\n        @include fontSize(12);\n        text-transform: uppercase;\n        margin-inline-end: 10px;\n      }\n    }\n    .apexcharts-tooltip {\n      padding: 16px 0;\n      border: 1px solid var(--borderColor);\n      background: #fff;\n      border-radius: 0;\n      box-shadow: none;\n      width: 272px;\n    }\n\n    .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n      padding: 0 16px 10px 16px;\n      background-color: transparent;\n      margin-bottom: 0;\n      font-size: 0 !important;\n      text-transform: uppercase;\n      color: var(--mainColor);\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      border-bottom: 0;\n      display: none;\n\n      &::before {\n        content: 'Hashtags';\n        @include fontSize(12);\n        flex-basis: 72%;\n      }\n\n      &::after {\n        content: 'Mentions';\n        display: block;\n        @include fontSize(12);\n      }\n    }\n    .apexcharts-tooltip.apexcharts-theme-light {\n      background-color: var(--bgColor);\n      border: var(--borderColor);\n    }\n    .apexcharts-tooltip-series-group {\n      padding: 0 16px;\n      @include fontSize(10);\n      width: 100%;\n\n      &:not(:last-child) {\n        margin-bottom: 9px;\n      }\n\n      .apexcharts-tooltip-marker {\n        flex-shrink: 0;\n      }\n\n      .apexcharts-tooltip-y-group {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        width: 100%;\n        @include fontSize(10);\n        color: var(--mainColor);\n      }\n\n      .apexcharts-tooltip-text {\n        width: 100%;\n      }\n\n      .apexcharts-tooltip-text-label {\n        flex-basis: 70%;\n      }\n\n      .apexcharts-tooltip-text-value {\n        margin-left: 0;\n        font-weight: 400;\n        color: var(--mainColor);\n      }\n    }\n  }\n\n  :global {\n    .arrow_box {\n      display: flex;\n      // align-items: center;\n      justify-content: space-between;\n      padding: 0 20px;\n\n      & > div h6 {\n        @include fontSize(12);\n        margin-bottom: 10px;\n        text-transform: uppercase;\n      }\n\n      & > div > div > div {\n        @include fontSize(10);\n        margin-bottom: 10px;\n        // white-space: normal;\n        max-width: 155px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        line-height: 1;\n        height: 12px;\n      }\n    }\n  }\n}\n:global {\n  .color_name {\n    display: flex;\n    align-items: center;\n    .colorBox {\n      min-width: 12px;\n      height: 12px;\n      margin-inline-end: 4px;\n      border: 1px solid;\n      margin-bottom: 0 !important;\n    }\n  }\n}\n.withSecondaryTable {\n  height: 0 !important;\n}\n:global {\n  .apexcharts-yaxis-texts-g.apexcharts-xaxis-inversed-texts-g {\n    #{$rtl} & {\n      transform: translateX(-5%) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `StackedColumnChart_scroll__loY09`,
	"StackedColumnChart": `StackedColumnChart_StackedColumnChart__uQBGi`,
	"unAnalyzed": `StackedColumnChart_unAnalyzed__HOyho`,
	"ChartBox": `StackedColumnChart_ChartBox__S9X5M`,
	"ChartBox__toolBar": `StackedColumnChart_ChartBox__toolBar__eWOpX`,
	"Filters": `StackedColumnChart_Filters__3g3py`,
	"Select": `StackedColumnChart_Select__9KVeG`,
	"Actions": `StackedColumnChart_Actions__qAmvu`,
	"ActionBtn": `StackedColumnChart_ActionBtn__PM9nI`,
	"specityChartHolder": `StackedColumnChart_specityChartHolder__3dUxa`,
	"specifyChart": `StackedColumnChart_specifyChart__T6ZeW`,
	"colorBox": `StackedColumnChart_colorBox__w4K9K`,
	"withSecondaryTable": `StackedColumnChart_withSecondaryTable__XZAgC`
};
export default ___CSS_LOADER_EXPORT___;
